import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';




const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);


const rows = [
  {
    item: 'Frozen Yogurt',
    quantity: '159 pc',
    price: '$159'
  },
  {
    item: 'Chicken Breast',
    quantity: '10 lb',
    price: '$24'
  },
  {
    item: 'Cupcakes',
    quantity: '12 pc',
    price: '$3'
  },
  {
    item: 'Apples',
    quantity: '30 pc',
    price: '$15'
  },
  {
    item: 'Coco Puffs',
    quantity: '2 boxes',
    price: '$5'
  },
];

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 100,
  },
  button: {
    margin: theme.spacing(1),

  },
  input: {
    display: 'none',
  },
}));


export default function GroceryList(props) {
  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  const toHome = () => {
    props.history.push("/home")
  }
  const toCart = () => {
    props.history.push("/cart")
  }
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <StyledTableCell>Item</StyledTableCell>
            <StyledTableCell align="right">Quantity</StyledTableCell>
            <StyledTableCell align="right">Price</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <StyledTableRow key={row.item}>
              <StyledTableCell component="th" scope="row">
                {row.item}
              </StyledTableCell>
              <StyledTableCell align="right">{row.quantity}</StyledTableCell>
              <StyledTableCell align="right">{row.price}</StyledTableCell>
            </StyledTableRow>

          ))}
        </TableBody>
      </Table>
      <ul>
        <Fab onClick={handleClickOpen} color="primary" aria-label="Add" className={classes.fab}>
          <AddIcon />
        </Fab>
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Add Item to Grocery List</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please add your item.
          </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Item Name"
              type="email"
              fullWidth
            />
                <TextField
                  autoFocus
                  margin="dense"
                  id="qty"
                  label="Quantity"
                  type="email"
                  fullWidth
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="qty-unit"
                  label="Unit"
                  type="email"
                  fullWidth
                />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
          </Button>
            <Button onClick={handleClose} color="primary">
              Add Item
          </Button>
          </DialogActions>
        </Dialog>
      </ul>
      <ul>
        <Button variant="contained" color="primary" onClick={toCart} className={classes.button}> <i className="material-icons"> shopping_cart </i>Go to Shopping Cart</Button>
      </ul>
      <ul>
        <Button variant="contained" onClick={toHome} className={classes.button}> <i className="material-icons"> home </i> Home</Button>
      </ul>

    </Paper>
  );
}
